<ui-section>
  <ui-block width="fill">
    <markdown class="mt-0" [data]="docMd">
    </markdown>
  </ui-block>

  <ui-block width="3x">
    <ui-panel
      [panelHeaderConfig]="{panelHeaderTitle: 'autoSizeStrategy settings'}"
    >
      <ui-form
        [config]="autoSizeFormConfig"
        [(formValues)]="autoSizeStrategyFormValues"

        (formValuesChange)="onAutoSizeStrategyFormValuesChange($event)"
        (formValuesDelta)="onAutoSizeStregyTypeChange($event)"
        (buttonClick)="onAutoSizeClick($event)"
        >
      </ui-form>
      <pre><code>{{ autoSizeStrategy | json}}</code></pre>

    </ui-panel>
  </ui-block>

  <ui-block width="4x">
    <ui-panel panelTitle="Column Definitions" subtitle="Play with these to see how it affects the grid"
    [panelHeaderConfig]="colDefsPanelHeaderConfig"
    [(additionalActionsFormValues)]="colDefsPanelAddActFormValues"
    (additionalActionsFormValuesChange)="onUseColDefChanged()"
      >
      <ui-form
        [config]="colDefForm"
        [(formValues)]="colDefFormValues"
        (formValuesChange)="onColDefsChange($event)"
        ></ui-form>
    </ui-panel>
  </ui-block>

</ui-section>

<ui-section>
  <ui-grid #ezGrid *ngIf="gridInstanceId"
    [readEndpoint]="starWarsEndpoint"
    [pageSizes]="[5, 10, 20]"
    [agGridOptions]="{paginationPageSize:10}"
    [panelHeaderConfig]="ezPanelHeaderConfig"
    [showPanelHeader]="true"
    [autoSizeStrategy]="autoSizeStrategy"
    [columnDefs]="colDefsPanelAddActFormValues['useColDefs'] ?  starWarsActorColDefs : []"

    [showBlankRowsOnLastPage]="!!ezAdditionActionFormValues['blankRows']"

    [(additionalActionsFormValues)]="ezAdditionActionFormValues"

    [reloadOnChangeTrigger]="reloadTrig()"
    (panelHeaderButtonClick)="reloadTrig.pulse()"

  />
</ui-section>
